@if (showPopup()) {
  <div class="incoming-call-toast shadow-lg">
    <div class="toast-body">
      <div class="caller-info">
        <div class="avatar">
          {{ (displayName || incomingNumber || 'U')[0].toUpperCase() }}
        </div>
        <div class="details">
          <p class="m-0 fs-12 text-uppercase fw-bold text-primary">Incoming Call</p>
          <h4
            [routerLink]="leadId ? ['/app/sales/my-leads-details'] : null"
            [queryParams]="leadId ? { lead_id: leadId } : null"
            [style.cursor]="leadId ? 'pointer' : 'default'"
            class="m-0 fs-16 fw-600">
            {{ displayName || incomingNumber || 'Unknown Caller' }}
          </h4>
          <p class="m-0 fs-12 text-muted">{{ incomingNumber }}</p>
        </div>
      </div>
      <div class="toast-actions">
        <button class="btn btn-danger rounded-pill px-4 d-flex align-items-center" (click)="decline()">
          <img src="assets/images/icons/call-ended.svg" width="18" class="me-2"> Reject
        </button>
        <button class="btn btn-success rounded-pill px-4 d-flex align-items-center" (click)="answer()">
          <img src="assets/images/icons/phone-white-icon.png" width="18" class="me-2"> Accept
        </button>
      </div>
    </div>
  </div>
}